import { useStyletron } from 'baseui'

const useIconCarbonDownload = (props = {}) => {
  const [, theme] = useStyletron()

  const title = props.title ?? 'Download'
  const size = props.size ?? 16
  const color = props.color ?? theme.colors.primary
  const overrides = props.overrides
  const ref = props.ref

  return { title, size, color, overrides, ref }
}

export default useIconCarbonDownload
